import React from 'react';


import FormElement from '../FormElement';
import Select from '../../Select';


function FormSelect(props) {

    return (
        <FormElement {...props}>
            <Select {...props}/>
        </FormElement>
    );
}


FormSelect.propTypes = {
    ...FormElement.propTypes,
    ...Select.propTypes
};

FormSelect.defaultProps = {
    ...FormElement.defaultProps,
    ...Select.defaultProps
};


export default FormSelect;
